import React, { type ReactNode } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';

import { colors } from '../../core/theme/tokens';

type FrozenColumnScrollProps = {
  frozenWidth: number;
  frozen: ReactNode;
  scrollable: ReactNode;
};

/**
 * Horizontal table scroller with the first column pinned, so Year / Period
 * stays visible while money columns swipe.
 */
export function FrozenColumnScroll({
  frozenWidth,
  frozen,
  scrollable,
}: FrozenColumnScrollProps) {
  return (
    <View style={styles.split}>
      <View style={[styles.frozen, { width: frozenWidth }]}>{frozen}</View>
      <ScrollView
        horizontal
        nestedScrollEnabled
        directionalLockEnabled
        showsHorizontalScrollIndicator
        style={styles.scroll}
        keyboardShouldPersistTaps="handled"
      >
        {scrollable}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  split: {
    flexDirection: 'row',
    width: '100%',
  },
  frozen: {
    zIndex: 2,
    backgroundColor: colors.surface,
    borderRightWidth: StyleSheet.hairlineWidth,
    borderRightColor: colors.glassBorder,
  },
  scroll: {
    flex: 1,
  },
});
